import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import * as jose from 'jose';
import { LoginCredentials } from 'src/app/models/LoginCredentials';
import { environment } from 'src/environments/environment';
import { EnvironmentService } from '../environment.service';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  constructor(private environmentService: EnvironmentService) { }

  jweSubject : Subject<string> = new Subject();
  jweSubjectObservable = this.jweSubject.asObservable();


  encryptPassword(text: string): any {
    const key = CryptoJS.enc.Utf8.parse(this.environmentService.get().passwordAesEncryptionKey);
    const encryptedPassword = CryptoJS.AES.encrypt(text, key, {
      keySize: 16,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
    return encryptedPassword;
  }

  decryptPassword(text: string): any {
    const key = CryptoJS.enc.Utf8.parse(this.environmentService.get().passwordAesEncryptionKey);
    const test = CryptoJS.AES.decrypt(text, key, {
      keySize: 16,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return test.toString(CryptoJS.enc.Utf8);
  }


  createJwtAuthentificationPayload(credentials : LoginCredentials) : Observable<string> {
    let seperateClaims = {
      'username': credentials.username,
      'password': credentials.password,
      'companyId': credentials.companyId,
      'companySiteId': credentials.companySiteId
    }
    if (this.environmentService.get().managerType && this.environmentService.get().managerType.length > 0) {
      seperateClaims['managerType'] = this.environmentService.get().managerType;
    }

    let secret = new TextEncoder().encode(this.environmentService.get().authTokenSecretKey)
    let jwt = new jose.SignJWT(seperateClaims)
      .setProtectedHeader({ 'alg': 'HS256' })
      .setIssuedAt()
      .setIssuer(this.environmentService.get().issuer)
      .setAudience(this.environmentService.get().audience)
      .setExpirationTime(this.environmentService.get().authTokenExpTimeSec)
      .sign(secret);

    jwt.then(jwts => {
      const publicKeyPKCS8 = this.environmentService.get().authTokenPublicKey;
        jose.importSPKI(publicKeyPKCS8, 'RSA-OAEP', { extractable: false }).then(publicKey => {
          const jwe = new jose.CompactEncrypt(new TextEncoder().encode(jwts))
            .setProtectedHeader({ alg: 'RSA-OAEP', enc: 'A128CBC-HS256' })
            .encrypt(publicKey);
        jwe.then(jweToken => {
          this.jweSubject.next(jweToken);
        })
        });
    });
    return this.jweSubjectObservable;
  }

  createJwtRefreshPayload(credentials : LoginCredentials) : Observable<string> {
    let seperateClaims = {
      'username': 'refresh_token',
      'password': this.encryptPassword('refresh_token'),
      'companyId': 0,
      'refresh': credentials.refresh
    }

    let secret = new TextEncoder().encode(this.environmentService.get().authTokenSecretKey)
    let jwt = new jose.SignJWT(seperateClaims)
      .setProtectedHeader({ 'alg': 'HS256' })
      .setIssuedAt()
      .setIssuer(this.environmentService.get().issuer)
      .setAudience(this.environmentService.get().audience)
      .setExpirationTime(this.environmentService.get().authTokenExpTimeSec)
      .sign(secret);

    jwt.then(jwts => {
      const publicKeyPKCS8 = this.environmentService.get().authTokenPublicKey;
        jose.importSPKI(publicKeyPKCS8, 'RSA-OAEP', { extractable: false }).then(publicKey => {
          const jwe = new jose.CompactEncrypt(new TextEncoder().encode(jwts))
            .setProtectedHeader({ alg: 'RSA-OAEP', enc: 'A128CBC-HS256' })
            .encrypt(publicKey);
        jwe.then(jweToken => {
          this.jweSubject.next(jweToken);
        })
        });
    });
    return this.jweSubjectObservable;
  }


}
